import React from 'react';
import SiteBannerOverlay from '@components/SiteBannerOverlay';
import { useSiteBannerLogic } from '@hooks/logic/useSiteBannerLogic';

const SiteBannerHost = () => {
    const { banner, dismissBanner, neverShowBannerAgain } = useSiteBannerLogic();

    return (
        <SiteBannerOverlay
            banner={banner}
            onDismiss={dismissBanner}
            onNeverShowAgain={neverShowBannerAgain}
        />
    );
};

export default SiteBannerHost;
